import { render, staticRenderFns } from "./repClientDetails.vue?vue&type=template&id=817c9a5a&"
import script from "./repClientDetails.vue?vue&type=script&lang=js&"
export * from "./repClientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports